import DashboardIcon from '@mui/icons-material/Dashboard';
import HubIcon from '@mui/icons-material/Hub';
import ShieldIcon from '@mui/icons-material/Shield';
import DescriptionIcon from '@mui/icons-material/Description';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupIcon from '@mui/icons-material/Group';
import SecurityIcon from '@mui/icons-material/Security';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import ActivityIcon from '@mui/icons-material/ShowChart';
import PeopleIcon from '@mui/icons-material/People';
import ChatIcon from '@mui/icons-material/Chat';
import TimelineIcon from '@mui/icons-material/Timeline';
import DownloadIcon from '@mui/icons-material/Download';
import ExtensionIcon from '@mui/icons-material/Extension';
import AssessmentIcon from '@mui/icons-material/Assessment';
import SpeedIcon from '@mui/icons-material/Speed';

export const topNavItems = [
  { id: 'overview', label: 'Overview', icon: DashboardIcon, path: '/overview' },
];

export const pillars = [
  {
    id: 'profile360',
    label: 'Profile360',
    shortLabel: '360',
    icon: HubIcon,
    color: 'primary.main',
    colorHex: '#6366f1',
    basePath: '/knowledge-graph',
    items: [
      { id: 'explorer', label: 'Explorer', icon: HubIcon, path: '/knowledge-graph/graphrag' },
      { id: 'access-review', label: 'Access Review', icon: ChatIcon, path: '/access-review' },
    ],
  },
  {
    id: 'risk',
    label: 'Risk Posture',
    shortLabel: 'P1',
    icon: ShieldIcon,
    color: 'pillar.risk',
    colorHex: '#3b82f6',
    basePath: '/risk-posture',
    items: [
      { id: 'risk-dashboard', label: 'Dashboard', icon: AssessmentIcon, path: '/risk-posture' },
      { id: 'privilege-creep', label: 'Privilege Creep', icon: TrendingUpIcon, path: '/risk-posture/privilege-creep' },
      { id: 'excessive-access', label: 'Excessive Access', icon: GroupIcon, path: '/risk-posture/excessive-access' },
      { id: 'dormant-users', label: 'Dormant Users', icon: PersonOffIcon, path: '/risk-posture/dormant-users' },
      { id: 'suspicious-activity', label: 'Suspicious Activity', icon: ActivityIcon, path: '/trust-intelligence/suspicious-activity' },
      { id: 'all-users', label: 'All Users', icon: PeopleIcon, path: '/risk-posture/users' },
    ],
  },
  {
    id: 'evidence',
    label: 'Evidence & Compliance',
    shortLabel: 'P2',
    icon: DescriptionIcon,
    color: 'pillar.evidence',
    colorHex: '#5da87a',
    basePath: '/evidence',
    items: [
      { id: 'compliance', label: 'Compliance', icon: SecurityIcon, path: '/evidence' },
      { id: 'timeline', label: 'Timeline', icon: TimelineIcon, path: '/evidence/timeline' },
      { id: 'export', label: 'Export', icon: DownloadIcon, path: '/evidence/export' },
    ],
  },
  {
    id: 'trust',
    label: 'Trust Intelligence',
    shortLabel: 'P3',
    icon: WarningAmberIcon,
    color: 'pillar.trust',
    colorHex: '#d4925e',
    basePath: '/trust-intelligence',
    items: [
      { id: 'trust-dashboard', label: 'Dashboard', icon: SpeedIcon, path: '/trust-intelligence' },
      { id: 'velocity', label: 'Velocity Analysis', icon: ActivityIcon, path: '/trust-intelligence/velocity' },
    ],
  },
  {
    id: 'ai',
    label: 'AI Governance',
    shortLabel: 'P4',
    icon: SmartToyIcon,
    color: 'pillar.ai',
    colorHex: '#a855f7',
    disabled: true,
    basePath: '/ai-governance',
    items: [],
  },
];

export const bottomNavItems = [
  { id: 'integrations', label: 'Integrations', icon: ExtensionIcon, path: '/integrations' },
];
